<script setup lang="ts">
// Display-only social proof for an event. Counts are always-present ints shown
// to every viewer. A segment whose count is 0 is hidden; when both are 0 the
// component renders nothing so cards stay clean. No interactivity, no emits.
const props = defineProps<{
  interestedCount: number;
  goingCount: number;
  class?: string;
}>();

const showInterested = computed(() => props.interestedCount > 0);
const showGoing = computed(() => props.goingCount > 0);
const hasAny = computed(() => showInterested.value || showGoing.value);
</script>

<template>
  <div
    v-if="hasAny"
    :class="[
      'social-proof-counts',
      'text-caption',
      'text-medium-emphasis',
      props.class,
    ]"
  >
    <span v-if="showInterested" class="social-proof-counts__segment">
      <v-icon icon="mdi-heart" size="x-small" class="me-1" />{{
        interestedCount
      }}
      interested
    </span>
    <span
      v-if="showInterested && showGoing"
      class="social-proof-counts__separator"
    >
      &middot;
    </span>
    <span v-if="showGoing" class="social-proof-counts__segment">
      <v-icon icon="mdi-check-circle" size="x-small" class="me-1" />{{
        goingCount
      }}
      going
    </span>
  </div>
</template>
